import { define, type, auto, Record, Collection } from 'type-r'
import ValidRecord from './valid_record'

@define 
export default class CancellationPolicyForm extends ValidRecord {
    @(type(null).required.as) signature: any
}